import { render, staticRenderFns } from "./detail_tes.vue?vue&type=template&id=d969b960&scoped=true"
import script from "./detail_tes.vue?vue&type=script&lang=js"
export * from "./detail_tes.vue?vue&type=script&lang=js"
import style0 from "./detail_tes.vue?vue&type=style&index=0&id=d969b960&prod&lang=css"
import style1 from "./detail_tes.vue?vue&type=style&index=1&id=d969b960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d969b960",
  null
  
)

export default component.exports